import { Suspense } from "react";
import { AuthProvider } from "providers/AuthProvider";
import { LoadingProvider } from "providers/LoadingProvider";
import { AlertsProvider } from "providers/AlertProvider";
import { PrimeReactProvider, addLocale } from "primereact/api";

addLocale("fr", {
  firstDayOfWeek: 1,
  dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
  dayNamesShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
  dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
  monthNames: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
  monthNamesShort: ["jan", "fév", "mar", "avr", "mai", "jun", "jul", "aoû", "sep", "oct", "nov", "déc"],
  today: "Aujourd'hui",
  clear: "Effacer",
});
// import Tailwind from "primereact/passthrough/tailwind";

type Props = {
  children: JSX.Element;
};

function AppProvider({ children }: Props) {
  return (
    <Suspense>
      <PrimeReactProvider value={{ unstyled: false }}>
        <LoadingProvider>
          <AlertsProvider>
            <AuthProvider>
              {children}
            </AuthProvider>
          </AlertsProvider>
        </LoadingProvider>
      </PrimeReactProvider>
    </Suspense>
  );
}

export default AppProvider;
